import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    DASHBOARD_SCAN_FAIL, // Renamed action type
    DASHBOARD_SCAN_REQUEST, // Renamed action type
    DASHBOARD_SCAN_SUCCESS, // Renamed action type
    FORGET_REQUEST,
    FORGET_FAIL,
    FORGET_SUCCESS,
    CLEAR_ERRORS,
    CHANGE_PASSWORD_REQUEST,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAIL,
    VERIFY_OTP_REQUEST,
    VERIFY_OTP_SUCCESS,
    VERIFY_OTP_FAIL,
    RESEND_OTP_REQUEST,
    RESEND_OTP_SUCCESS,
    RESEND_OTP_FAIL,
    DASHBOARD_RESET,
    OTP_VERIFICATION_RESET
} from '../constant/userConstant';

const initialState = {
    user: localStorage.getItem('token') ? { token: localStorage.getItem('token') } : null,
    loading: false,
    isAuthenticated: !!localStorage.getItem('token'),
    error: null
};

export const authReducer = (state = initialState, action) => {
    console.log('Token:', state);
    switch (action.type) {
        case LOGIN_REQUEST:
        case LOGOUT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case LOGIN_SUCCESS:
            return {
                ...state,
                loading: false,
                isAuthenticated: true,
                user: action.payload,
                error: null
            };

        case LOGOUT_SUCCESS:
            localStorage.removeItem('token');
            return {
                loading: false,
                isAuthenticated: false,
                user: null,
                error: null
            };

        case LOGIN_FAIL:
            localStorage.removeItem('token');
            return {
                ...state,
                loading: false,
                isAuthenticated: false,
                user: null,
                error: action.payload
            };

        case LOGOUT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};

export const dashboardReducer = (state = { dashboadData: null, loading: false, error: null }, action) => {
    switch (action.type) {
        case DASHBOARD_SCAN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case DASHBOARD_SCAN_SUCCESS:
            return {
                ...state,
                loading: false,
                dashboadData: action.payload,
            };
        case DASHBOARD_SCAN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case DASHBOARD_RESET:
            return {
                ...state,
                dashboadData: null,
                loading: false,
                error: null,
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };
        default:
            return state;
    }
};


export const resetReducer = (state = { message: null, loading: false, error: null }, action) => {
    switch (action.type) {
        case FORGET_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case FORGET_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.payload,
            };
        case FORGET_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export const changePasswordReducer = (state = { message: null, loading: false, error: null }, action) => {
    switch (action.type) {
        case CHANGE_PASSWORD_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.payload,
            };
        case CHANGE_PASSWORD_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };
        default:
            return state;
    }
};

export const otpVerificationReducer = (state = { message: null, loading: false, error: null }, action) => {
    switch (action.type) {
        case VERIFY_OTP_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        case VERIFY_OTP_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.payload,
                error: null
            };
        case VERIFY_OTP_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null
            };
        case RESEND_OTP_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        case RESEND_OTP_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.payload,
                error: null
            };
        case RESEND_OTP_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null
            };
        case OTP_VERIFICATION_RESET:
            return {
                ...state,
                loading: false,
                error: null,
                message: null
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };
        default:
            return state;
    }
};